import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { takeUntil } from 'rxjs';
import { BaseComponent } from './../../../../core/components/base/base.component';
import { ProcedureCode } from './../../../../core/services/app-data.service';
import { FeedbackService } from './../../../../core/services/feedback.service';
import { HospitalService } from './../../../../core/services/hospital.service';
@Component({
  selector: 'app-auto-billing-settings',
  templateUrl: './auto-billing-settings.component.html',
  styleUrls: ['./auto-billing-settings.component.scss']
})

export class AutoBillingSettingsComponent extends BaseComponent {

  @Output() autoBillingChanged = new EventEmitter<any[]>();

  hospitals: any = null;

  readonly separatorKeysCodes: number[] = [13, 188]; // Enter and comma key codes
  addOnBlur = true;

  constructor(private hospitalService: HospitalService, fs: FeedbackService, md: MatDialog) {
    super(fs, md);
    this.hospitalService.hospitals$
      .pipe(takeUntil(this.destroy$))
      .subscribe(hospitals => {
        if (hospitals) {
          this.hospitals = hospitals
            // 1. sort hospitals by name
            .sort((a: any, b: any) => a.name.localeCompare(b.name))
            // 2. for each hospital, sort its wards by name
            .map((h: any) => ({
              ...h,
              wards: (h.wards || []).sort((w1: any, w2: any) =>
                w1.name.localeCompare(w2.name)
              )
            }));
        }
      });
  }

  onProcedureCodesChanged(codes: ProcedureCode[], hospital: any, wardIndex: number) {
    hospital.wards[wardIndex].procedureCodes = codes;
    const sub = this.hospitalService.updateWardCoding(this.hospitals)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          this.autoBillingChanged.emit(this.hospitals);
          sub.unsubscribe();
          //this.showToastMessage('Coding settings updated successfully');
        },
        (error) => {
          console.error('Error updating coding settings:', error);
          this.showToastMessage('There was an error updating your coding settings. Please try again.');
          sub.unsubscribe();
        }
      );
  }
}
